import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LiveChatService {
  private isBrowser: boolean

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  
  hideChatWidget(): void {
    if (!this.isBrowser) return;
    if (typeof window !== 'undefined' && window.zE) {
      window.zE('messenger', 'hide');
    } else {
      console.warn('Function zE() is not available on the window global object.');
    }
  }

  showChatWidget(): void {
    if (!this.isBrowser) return;
    if (typeof window !== 'undefined' && window.zE) {
      window.zE('messenger', 'show');
    } else {
      console.warn('Function zE() is not available on the window global object.');
    }
  }

  enableCookies(enable: boolean): void {
    if (!this.isBrowser) return;
    if (typeof window !== 'undefined' && window.zE) {
      window.zE('messenger:set', 'cookies', enable);
    } else {
      console.warn('Function zE() is not available on the window global object.');
    }
  }
}
